import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=49c88f02&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=js"
export * from "./NoteModal.vue?vue&type=script&lang=js"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=49c88f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c88f02",
  null
  
)

export default component.exports